"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postNumber = postNumber;
var _common = require("./common");
function postNumber(url, token, queryParams) {
  var options = {
    method: 'POST',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    credentials: 'include',
    body: JSON.stringify(queryParams)
  };
  return (0, _common.request)(url, options);
}